import cn from 'classnames';
import { useNavigate } from 'react-router-dom';

import styles from './Row.module.sass';
import { IEventListItem } from '@types';
import { getFullImagePath } from 'core/utils/image';
import Icon from 'components/Icon';
import { paths } from 'router/paths';

interface RowProps {
  item: IEventListItem;
  onDelete: (id: string) => void;
}

const Row = ({ item, onDelete }: RowProps) => {
  const navigate = useNavigate();
  const navigateToEdit = (id: string) => {
    navigate(paths.EVENTS_MODIFY_PATH.replace(':id', id));
  };

  const navigateToDetails = (id: string) => {
    navigate(paths.EVENTS_DETAILS_PATH.replace(':id', id));
  };

  return (
    <>
      <div className={cn(styles.row)}>
        <div className={styles.col}></div>
        <div className={styles.col}>
          <div className={styles.item} onClick={() => navigateToDetails(item.id)}>
            <div className={styles.photo}>
              <img src={getFullImagePath(item.imageUrl)} alt="Avatar" />
            </div>
            <div className={styles.details}>
              <div className={styles.user}>{item.title}</div>
            </div>
          </div>
        </div>

        <div className={styles.col}>{item.date}</div>
        <div className={styles.col}>
          <button
            onClick={() => navigateToEdit(item.id)}
            className={cn('button', 'button-small', 'button-stroke', styles.button)}
          >
            <Icon name="edit" size="24" />
          </button>
          <button
            onClick={() => navigateToDetails(item.id)}
            className={cn('button', 'button-small', 'button-stroke', styles.button)}
          >
            <Icon name="ticket" size="24" />
          </button>
          <button
            onClick={() => onDelete(item.id)}
            className={cn('button', 'button-small', 'button-stroke-red', styles.button)}
          >
            <Icon name="close" size="24" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Row;
